<template>
	<div>
		<modalDetail :dialog="dialogDetail" @hideDialog="() => { dialogDetail = false }"></modalDetail>
		<modalconfirm supplier ref="modalDelivPDO" @action="delivePDO"/>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Pengiriman Pemesanan</div>
		</div>
		<div v-if="loading">
			<loading-card-supplier></loading-card-supplier>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="grey lighten-3" dark class="pa-3">
					<v-list-item dense class="px-1">
						<v-spacer></v-spacer>
						<v-btn text depressed class="cyan darken-2 mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="cyan darken-2" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<v-col class="px-3">
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Pengiriman" v-model="pdo_code.value" color="cyan darken-2"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Pemesanan" v-model="po_code.value" color="cyan darken-2"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="dateCreate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined hide-details dense :value="convertDate(on_delivery)" label="Tanggal Dikirim" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="cyan darken-2"></v-text-field>
									</template>
									<v-date-picker range color="cyan darken-2" v-model="on_delivery"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="dateSent" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined hide-details dense :value="convertDate(delivery_date)" label="Tanggal Diterima" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="cyan darken-2"></v-text-field>
									</template>
									<v-date-picker range color="cyan darken-2" v-model="delivery_date"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="" outlined dense hide-details v-model="pdo_status.value" :items="listStatusPDO" label="Status PDO" color="cyan darken-2" item-color="cyan darken-2" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										{{item | toStatusPDOWH}}
									</template>
									<template v-slot:selection = {item}>
										{{item | toStatusPDOWH}}
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="6"></v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn @click="resetFilter" outlined color="grey darken-1" class="text-capitalize" dark>Reset</v-btn>
								<v-btn @click="cari" depressed color="cyan darken-2" dark class="ml-2 text-capitalize">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<div outlined v-if="listPDO.length == 0 && pdoPagination">
				<div class="py-3">
					<not-found-cyan></not-found-cyan>
				</div>
			</div>
			<div v-else>
				<v-row class="mr-0">
					<v-col cols="12" md="12" class="pb-0 pr-0" >
						<v-card class="mb-3" outlined v-for="pdo in listPDO" :key="pdo.pdo_id">
							<v-list color="grey lighten-3" class="pt-0 pb-0">
								<v-list-item dense>
									<v-list-item-content class="grey--text text--darken-2">
										Kode Pengiriman {{ pdo.pdo_code }}
									</v-list-item-content>
									<v-spacer></v-spacer>
									<v-btn small text depressed class="cyan darken-2" dark @click="printPDO(pdo.pdo_code)">
										<v-icon>mdi-printer</v-icon>
										<div class="pl-2 text-capitalize">Print</div>
									</v-btn>
								</v-list-item>
							</v-list>
							<v-list-item>
								<v-list-item-content>
									<v-layout wrap>
										<v-flex xs6 sm3 md3>
											<div class="body-2 oppacity-75">Tujuan</div>
											<div class="subtitle-2">{{ pdo.warehouse_name }}</div>
										</v-flex>
										<v-flex xs6 sm3 md3>
											<div class="body-2 oppacity-75">Kode Pemesanan</div>
											<div class="subtitle-2">{{ pdo.po_code }}</div>
										</v-flex>
										<v-flex xs6 sm3 md3>
											<div class="body-2 oppacity-75">Tanggal Kirim</div>
											<div class="subtitle-2">{{ pdo.pdo_estimated_sent_date | haritanggal }}</div>
										</v-flex>
										<v-flex xs6 sm3 md3>
											<div class="body-2 oppacity-75">Status</div>
											<div class="subtitle-2">{{ pdo.pdo_status | toStatusPDOWH }}</div>
										</v-flex>
										<v-flex xs6 sm6 md6>
											<div class="body-2 pt-3">
												<v-icon small>mdi-phone</v-icon><span class="pl-2">{{ pdo.warehouse_mobilephone }}</span>
											</div>
											<div class="body-2 pt-1">
												<v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ pdo.warehouse_address }}</span>
											</div>
										</v-flex>
										<v-flex xs6 sm6 md3 v-if="pdo.pdo_status == 'delivered'">
											<div class="body-2 oppacity-75 pt-3">Tanggal Diterima</div>
											<div class="subtitle-2">{{ pdo.pdo_status_delivered_datetime | haritanggal }}</div>
										</v-flex>
										<v-flex xs6 sm6 md3 v-else>
											<div class="body-2 oppacity-75 pt-3">Estimasi Diterima</div>
											<div class="subtitle-2">{{ pdo.pdo_estimated_received_date | haritanggal }}</div>
										</v-flex>
										<v-flex xs6 sm3 md3>
											<div class="pt-4">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on" @click.stop="getDetail(pdo.pdo_code)">
															<v-icon dark>mdi-text-box-search</v-icon>
														</v-btn>
													</template>
													<span>Detail</span>
												</v-tooltip>
											</div>
										</v-flex>
									</v-layout>
								</v-list-item-content>
							</v-list-item>
							<div class="pt-3">
								<v-card tile elevation="0">
									<v-data-table dense :headers="headersProduct" :items="pdo.pdo_detail" :items-per-page="1000" class="elevation-0 white-row" hide-default-footer>
										<template v-slot:item.pdo_detail_quantity_sent="{ item }">
											<div>{{ item.pdo_detail_quantity_sent | toNumber }}</div>
										</template>
										<template v-slot:item.pdo_detail_quantity_received="{ item }">
											<div v-if="item.pdo_detail_quantity_received > 0">{{ item.pdo_detail_quantity_received | toNumber }}</div>
											<div v-else>-</div>
										</template>
									</v-data-table>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="pt-5">
					<v-row>
						<v-col cols="10" md="11" class="py-0 d-flex justify-end">
							<v-pagination v-if="pdoPagination.total_page > 1 && listPDO.length > 0" v-model="page" @input="changePage" :length="pdoPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
						</v-col>
						<v-col cols="2" md="1" class="py-0 pl-0">
							<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import modalDetail from '@/views/MLsupplier/pdo/DetailPDO'
import modalPrint from '@/views/MLsupplier/pdo/PrintPDO'

export default {
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			dropfilter: false,
			dialogDetail: false,
			dialogPrint: false,
			loading: true,
			page: 1,
			listLimit: [ '5', '10', '20', '50', '100' ],
			limit: 10,
			params: [],
			sortBy: 'pdo_id',
			sortDir: 'DESC',
			dateCreate: false,
			dateSent: false,
			headersProduct: [
			{ text: 'Nama Produk', value: 'supplier_product_name', sortable: false },
			{ text: 'Jumlah Dikirim', value: 'pdo_detail_quantity_sent', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'pdo_detail_quantity_received', sortable: false, align: 'center' }
			],
			pdo_code: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'pdo_code'
			},
			po_code: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'po_code'
			},
			pdo_create_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'pdo_status_on_deliverytime'
			},
			pdo_delivery_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'pdo_status_delivered_datetime'
			},
			pdo_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'pdo_status'
			},
			on_delivery: [],
			delivery_date: [],
			pdo_id: '',
		}
	},
	computed: {
		...mapState('pdoSupplier', ['listPDO', 'pdoPagination', 'listStatusPDO']),
		...mapState('authSupplier', ['userData'])
	},
	methods: {
		...mapActions('pdoSupplier', ['getPDO', 'deliveryPDO', 'getStatusPDO', 'getDetailPDO', 'exportPDO']),
		...mapActions('commonSupplier', ['getLetterHeader']),
		...mapMutations(['setOverlay']),

		getData() {
			this.getPDO().then(() => {
				this.getStatusPDO().then(() => {
					this.loading = false
				})
			})
		},
		exportData() {
			this.exportPDO(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		resetFilter() {
			this.pdo_code.value = ''
			this.pdo_create_date.value = ''
			this.pdo_delivery_date.value = ''
			this.delivery_date = []
			this.on_delivery = []
			this.pdo_status.value = ''
			this.page = 1
			this.getPDO(this.queryString({limit:this.limit, page: this.page}))
		},
		cari() {
			this.params = []
			if (this.pdo_code.value)
				this.params.push(this.pdo_code)
			if (this.po_code.value)
				this.params.push(this.po_code)
			if (this.pdo_create_date.value) {
				if (this.pdo_create_date.value.length > 1) {
					this.pdo_create_date.value.sort()
					let date = this.pdo_create_date.value.join('::')
					this.pdo_create_date.value = date
				}
				this.params.push(this.pdo_create_date)
			}
			if (this.pdo_delivery_date.value) {
				if (this.pdo_delivery_date.value.length > 1) {
					this.pdo_delivery_date.value.sort()
					let date = this.pdo_delivery_date.value.join('::')
					this.pdo_delivery_date.value = date
				}
				this.params.push(this.pdo_delivery_date)
			}
			if (this.pdo_status.value)
				this.params.push(this.pdo_status)
			this.page = 1
			this.getPDO(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		proccessPDO(id) {
			this.pdo_id = id
			let msg = "Apakah anda yakin PDO ini sudah dikirim?"
			this.$refs.modalDelivPDO.setMessage(msg)
			this.$refs.modalDelivPDO.showConfirm()
		},
		async delivePDO() {
			await this.setOverlay(true)
			let params = await {
				pdo_id: this.pdo_id
			}
			await this.deliveryPDO(params).then(() => {
				this.getPDO(this.queryString({limit:this.limit, page: this.page, params:this.params}))
				this.$refs.modalDelivPDO.hideConfirm()
			})
			await this.setOverlay(false)
		},
		changePage(page) {
			this.page  = page
			this.getPDO(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getPDO(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		getDetail(code) {
			this.getDetailPDO(code).then(()=> {
				this.dialogDetail = true
			})
		},
		async printPDO(code) {
			await this.getLetterHeader({
				supplier_id: this.userData.user_supplier_supplier_id
			})
			await this.getDetailPDO(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Purchase Delivery Order`);
		this.getData()
	},
	watch: {
		on_delivery(val) {
			this.pdo_create_date.value = val
		},
		delivery_date(val) {
			this.pdo_delivery_date.value = val
		},
	}
}
</script>